const mockDisabledByUrl = () => {
  if (!import.meta.env.DEV) return false;
  try {
    return new URLSearchParams(window.location.search).get("mock") === "0";
  } catch {
    return false;
  }
};

export const IS_PROTO = import.meta.env.VITE_PROTO1 === "1" && !mockDisabledByUrl();
